export default __webpack_public_path__ + "static/media/thirdCarouselImage.88544f02.png";